const capFirstLetter = (word) => word && (word.charAt(0).toUpperCase() + word.slice(1));
export default capFirstLetter;
//# sourceMappingURL=capitalizeFirstLetter.js.map